// =====================================================================
//  SITE CONFIG & MOCK DATA
//  Edit everything here to personalize the site (payments, contacts,
//  products, reviews, FAQ, etc.). No need to touch any other file.
// =====================================================================

export const siteConfig = {
  brandName: "BigBank Bills",
  tagline: "Premium 1:1 Prop Bills",
  logoText: "BB",
  announcement: "Looking for Long Term Customers Only!",
  rating: "4.9",
  reviewCount: "300+",

  // ---- YOUR CONTACT DETAILS (replace with your own) ----
  contact: {
    telegramHandle: "",
    telegramLink: "",
    supportEmail: "support@bigbankbills.com",
    hours: "24/7 Support",
  },

  // ---- YOUR PAYMENT DETAILS (replace with your own) ----
  payments: [
    { id: "btc", name: "Bitcoin (BTC)", address: "bc1qxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx" },
    { id: "ltc", name: "Litecoin (LTC)", address: "ltc1qxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx" },
    { id: "cashapp", name: "Cash App", address: "$YourCashTag" },
    { id: "zelle", name: "Zelle", address: "your-email@example.com" },
  ],

  trustBadges: [
    { icon: "Zap", label: "Fast Shipping" },
    { icon: "Lock", label: "Discreet" },
    { icon: "BadgeCheck", label: "1:1 Quality" },
    { icon: "MessageCircle", label: "24/7 Support" },
  ],
};

export const products = [
  {
    id: "20s-collection",
    category: "Collections",
    name: "20s Collection",
    priceLabel: "$100.00 – $500.00",
    priceFrom: 100,
    badge: "Popular",
    badgeType: "popular",
    stock: "In Stock",
    delivery: "Delivered instantly",
    image: "/products/20s-1.jpeg",
    images: ["/products/20s-1.jpeg", "/products/20s-2.jpeg"],
    description:
      "Premium 1:1 replica $20 prop bills. Camera-ready detail and authentic stack feel, ideal for music videos, film scenes and photography sets.",
    options: [
      { label: "$100 Pack", price: 100 },
      { label: "$250 Pack", price: 250 },
      { label: "$500 Pack", price: 500 },
    ],
  },
  {
    id: "50s-collection",
    category: "Collections",
    name: "50s Collection",
    priceLabel: "$125.00 – $625.00",
    priceFrom: 125,
    badge: "New",
    badgeType: "new",
    stock: "In Stock",
    delivery: "Delivered instantly",
    image: "/products/50s-1.jpeg",
    images: ["/products/50s-1.jpeg", "/products/50s-2.jpeg"],
    description:
      "High-fidelity $50 prop bills with realistic printing and texture. A favourite for premium shoots and creator content.",
    options: [
      { label: "$125 Pack", price: 125 },
      { label: "$375 Pack", price: 375 },
      { label: "$625 Pack", price: 625 },
    ],
  },
  {
    id: "100s-collection",
    category: "Collections",
    name: "100s Collection",
    priceLabel: "$150.00 – $750.00",
    priceFrom: 150,
    badge: "Best Seller",
    badgeType: "best",
    stock: "In Stock",
    delivery: "Delivered instantly",
    image: "/products/100s-1.jpeg",
    images: ["/products/100s-1.jpeg"],
    description:
      "Our flagship $100 prop bills — the most requested stack on the market. Flawless 1:1 quality trusted by creators nationwide.",
    options: [
      { label: "$150 Pack", price: 150 },
      { label: "$450 Pack", price: 450 },
      { label: "$750 Pack", price: 750 },
    ],
  },
  {
    id: "mixed-bundle-25k",
    category: "Mixed Bundles",
    name: "25K Mixed Bundle",
    priceLabel: "$285.00",
    priceFrom: 285,
    badge: "Best Seller",
    badgeType: "best",
    stock: "In Stock",
    delivery: "Delivered instantly",
    image: "/products/100s-1.jpeg",
    images: ["/products/100s-1.jpeg", "/products/50s-1.jpeg", "/products/20s-1.jpeg"],
    description:
      "A curated mix of 20s, 50s and 100s totalling a 25K prop stack. The perfect all-in-one pack for versatile shoots.",
    options: [{ label: "25K Bundle", price: 285 }],
  },
  {
    id: "mixed-bundle-40k",
    category: "Mixed Bundles",
    name: "40K Mixed Bundle",
    priceLabel: "$410.00",
    priceFrom: 410,
    badge: "Best Seller",
    badgeType: "best",
    stock: "In Stock",
    delivery: "Delivered instantly",
    image: "/products/100s-1.jpeg",
    images: ["/products/100s-1.jpeg", "/products/50s-2.jpeg", "/products/20s-2.jpeg"],
    description:
      "Our largest curated mix — a 40K prop stack blending all denominations for big-production visuals.",
    options: [{ label: "40K Bundle", price: 410 }],
  },
  {
    id: "chime-sauce",
    category: "Digital Guides",
    name: "Chime Sauce",
    priceLabel: "$150.00",
    priceFrom: 150,
    badge: "New",
    badgeType: "new",
    stock: "In Stock",
    delivery: "Delivered instantly",
    image: "https://images.unsplash.com/photo-1636115734305-aac2f83cd8d4",
    images: ["https://images.unsplash.com/photo-1636115734305-aac2f83cd8d4"],
    description:
      "A premium digital guide delivered instantly to your inbox. Step-by-step creator resource — no shipping required.",
    options: [{ label: "Digital Guide", price: 150 }],
  },
];

export const whyBuy = [
  { icon: "Package", title: "100% Discreet Packaging", text: "Plain box, no labels revealing contents." },
  { icon: "Rocket", title: "Delivered Instantly", text: "Fast processing with tracking on all orders." },
  { icon: "Truck", title: "Tracking Provided", text: "Tracking number sent once your order ships." },
  { icon: "Headphones", title: "Support Available", text: "Reach us anytime on Telegram — fast replies." },
  { icon: "Clapperboard", title: "Made for Creators", text: "Music videos, film, photography & content props." },
  { icon: "Gem", title: "1:1 Quality", text: "Premium prop bills trusted by creators nationwide." },
];

export const howToOrder = [
  { step: 1, title: "Choose Your Bundle", text: "Browse the catalog and pick the pack that fits your need." },
  { step: 2, title: "Select Payment Method", text: "Choose BTC, Litecoin, Cash App or Zelle at checkout." },
  { step: 3, title: "Submit Shipping Info", text: "Enter your shipping address — fully discreet delivery." },
  { step: 4, title: "Receive Tracking", text: "We deliver instantly and send your tracking number." },
];

export const faqs = [
  {
    q: "Are these legal?",
    a: "Yes. Our products are prop bills intended solely for creative use — film, music videos, photography and content. They are clearly designed as props and are not legal tender.",
  },
  {
    q: "How fast do you ship?",
    a: "Orders are processed instantly and typically ship the same day. Most customers receive their order within 2–3 business days with tracking provided.",
  },
  {
    q: "Is packaging discreet?",
    a: "Absolutely. Every order ships in a plain box with no external labels or branding revealing the contents.",
  },
  {
    q: "How do I order?",
    a: "Pick a bundle, choose your payment method (BTC, Litecoin, Cash App or Zelle), submit your shipping details and you'll receive a tracking number once shipped.",
  },
];

export const reviews = [
  {
    handle: "@ivanmakesfilms",
    text: "Bills came in 2 days. Camera-ready and the stack feel is unreal — my music video clients are obsessed.",
    initials: "IM",
  },
  {
    handle: "@studio.nightowl",
    text: "Been ordering for a year. Best prints on the market, best support, always on time.",
    initials: "SN",
  },
  {
    handle: "@dcprodco",
    text: "Ordered the mixed bundle for a shoot — every stack was flawless. Repeat customer for life.",
    initials: "DC",
  },
];
